(() => {
  'use strict';
  if (window.onairBuildSliderLoaded) return;
  window.onairBuildSliderLoaded = true;
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-carousel-track]');
    const controls = root.querySelector('[data-carousel-controls]');
    if (!track || !controls) return;
    const slides = [...track.children];
    const previous = controls.querySelector('[data-carousel-prev]');
    const next = controls.querySelector('[data-carousel-next]');
    const pause = controls.querySelector('[data-carousel-pause]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const signal = controller.signal;
    let paused = root.dataset.autoplay !== 'true' || motion.matches;
    let visible = false;
    let hovering = false;
    let timer = null;
    const stop = () => { clearTimeout(timer); timer = null; };
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    function sync() {
      const canScroll = maxScroll() > 4;
      controls.hidden = !canScroll;
      previous.disabled = !canScroll || track.scrollLeft <= 4;
      next.disabled = !canScroll || track.scrollLeft >= maxScroll() - 4;
      pause.hidden = motion.matches;
      pause.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
      track.setAttribute('aria-live', paused ? 'polite' : 'off');
    }
    function schedule() {
      stop();
      if (paused || motion.matches || !visible || hovering || document.hidden || root.contains(document.activeElement) || maxScroll() < 5) return;
      timer = setTimeout(() => { advance(1, true); schedule(); }, 7000);
    }
    function advance(direction, automatic = false) {
      if (!automatic) { paused = true; stop(); }
      const box = track.getBoundingClientRect();
      const positions = slides.map(slide => slide.getBoundingClientRect().left - box.left + track.scrollLeft);
      let target = direction > 0 ? positions.find(x => x > track.scrollLeft + 5) : [...positions].reverse().find(x => x < track.scrollLeft - 5);
      if (automatic && track.scrollLeft >= maxScroll() - 5) target = 0;
      if (target !== undefined) track.scrollTo({left: Math.min(maxScroll(), Math.max(0, target)), behavior: motion.matches ? 'auto' : 'smooth'});
      sync();
    }
    previous.addEventListener('click', () => advance(-1), {signal});
    next.addEventListener('click', () => advance(1), {signal});
    pause.addEventListener('click', () => { paused = !paused; sync(); schedule(); }, {signal});
    root.addEventListener('mouseenter', () => { hovering = true; stop(); }, {signal});
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); }, {signal});
    root.addEventListener('focusin', () => { paused = true; stop(); sync(); }, {signal});
    root.addEventListener('focusout', () => setTimeout(schedule, 0), {signal});
    track.addEventListener('pointerdown', () => { paused = true; stop(); sync(); }, {signal, passive:true});
    track.addEventListener('wheel', () => { paused = true; stop(); sync(); }, {signal, passive:true});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); advance(event.key === 'ArrowLeft' ? -1 : 1);
    }, {signal});
    track.addEventListener('scroll', sync, {signal, passive:true});
    document.addEventListener('visibilitychange', schedule, {signal});
    motion.addEventListener('change', () => { if (motion.matches) paused = true; sync(); schedule(); }, {signal});
    let intersection;
    if ('IntersectionObserver' in window) {
      intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:.25});
      intersection.observe(root);
    } else { visible = true; }
    let resize;
    if ('ResizeObserver' in window) { resize = new ResizeObserver(() => { sync(); schedule(); }); resize.observe(track); }
    else window.addEventListener('resize', () => {sync(); schedule();}, {signal, passive:true});
    instances.set(root, () => { stop(); controller.abort(); intersection?.disconnect(); resize?.disconnect(); });
    sync(); schedule();
  }
  const setup = () => document.querySelectorAll('[data-onair-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => { if (event.target.contains(root)) { destroy(); instances.delete(root); } });
  });
})();
